import rateCriterion from './rate-criterion'
import pointCriterion from './point-criterion'

export default {
  name: 'BaseInfoFeedback',
  path: 'feedback',
  meta: {
    label: 'feedback',
    auth: 'feedback'
  },
  component: {
    name: 'Feedback',
    render(c) {
      return c('router-view')
    }
  },
  children: [rateCriterion, pointCriterion]
}
